import { Component, OnInit, Output, EventEmitter, Input, ViewChildren, QueryList } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { Availability, RouteOption, ProductUrl, TravelAlternative } from '../../../../models/availability.model';
import { BookingService, SectorOptions } from '../../../../services/booking.service';
import { TravelProductService } from '../../../../services/travel-product.service';
import { ActionUpdaterService, ApiError } from '../../../../services/action-updater.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RefreshAvailabilityByDateOption } from '../availability-wrapper/availability-wrapper.component';
import { GoogleMapComponent } from '../../../google-map/google-map.component';
import { SeatAllocationsComponent } from '../../../seat-allocations/seat-allocations.component';
import { Booking, Sector } from '../../../../models/booking.model';
import { ITINERARY_CONTEXT } from '../../../..//models/enums/context.enum';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Location } from '@angular/common';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { DeviceService } from 'app/shared/services/device.service';
import { FeatureService, Feature } from 'app/shared/services/feature.service';
import { PostTimetableOption } from 'app/shared/models/timetables.model';
import { TimetableService } from 'app/shared/services/timetable-service';
import { InitialDataService } from 'app/initial-data.service';
import { ProductTypeUrl } from 'app/shared/models/enums/ProductTypeUrl.enum';
import { TranslatePipe } from 'app/shared/pipes/translate.pipe';
import { DomSanitizer, SafeResourceUrl, SafeStyle, SafeUrl } from '@angular/platform-browser';
import { Observable } from '../../../../../../../node_modules/rxjs';
@Component({
    selector: 'gaweb-availability-table',
    templateUrl: './availability-table.component.html',
    animations: [
        trigger(
            'slideTransition',
            [
                state('in', style({})),
                transition('* => void', [
                    style({ height: '!', opacity: 1, overflow: 'hidden' }),
                    animate('200ms ease-out', style({ height: '0px', opacity: 0, overflow: 'hidden' }))
                ]),
                transition('void => *', [
                    style({ height: '0px', opacity: 0, overflow: 'hidden' }),
                    animate('200ms ease-out', style({ height: '!', opacity: 1, overflow: 'hidden' }))
                ])
            ]
        )]
})
export class AvailabilityTableComponent implements OnInit {
    static readonly fareDescriptions = {
        'Saver': 'Saver fare is non-changeable and non-refundable.',
        'Flexi': 'Flexi fare is non-refundable but can be changed.'
    };
    @Output() onRefreshAvailabilityByDate: EventEmitter<RefreshAvailabilityByDateOption> = new EventEmitter();
    @Output() onMoveToReturnSlide: EventEmitter<any> = new EventEmitter();
    @Output() onHandleChooseFare: EventEmitter<any> = new EventEmitter();

    @Input() availability: Availability;
    @Input() displayFares: boolean;
    @Input() buttonLabel: string;
    @Input() currentSlide: number;
    @Input() description: string;
    @Input() productUrl: ProductUrl;
    @Input() hasReturnTrip: boolean;
    @Input() bookingGuid: string;
    @Input() productReference: string;
    @Input() isAvailabilityPartOfReturnBooking: boolean;
    @Input() context: ITINERARY_CONTEXT;
    @Input() targetSector: number;
    @ViewChildren(GoogleMapComponent) googleMap: QueryList<GoogleMapComponent>;
    @ViewChildren(SeatAllocationsComponent) seatAllocations: QueryList<SeatAllocationsComponent>;

    fareColours: SafeStyle[] = [];
    fareColoursB: string[] = [];
    showPreviousDay: boolean;
    showNextDay: boolean;
    dayCurrent: Date;
    dayBefore: Date;
    dayAfter: Date;
    betterDayBefore: Date | null;
    betterDayAfter: Date | null;
    availabilityDataExists: boolean;
    nextAvailabilityDateExists: boolean;
    previousAvailabilityDateExists: boolean;
    gettingTimetable = false;
    addingSector = null;
    messages: string[] = [];
    travelAlternates: Array<TravelAlternative> = [];
    travelAlternatesExist = false;
    betterTravelAlternatives: Array<TravelAlternative> = [];
    betterTravelAlternativesExist = false;
    showAltTravelPanel = false;

    currentFares: { [key: string]: number; } = {};
    selectedSectors: Array<SectorOptions> = [];
    mapEnabled = false;

    get fareDescriptions() {
        return AvailabilityTableComponent.fareDescriptions;
    }

    constructor(private actionUpdaterService: ActionUpdaterService,
        private bookingService: BookingService,
        private travelPackageService: TravelProductService,
        private activatedRoute: ActivatedRoute,
        private pipe: TranslatePipe,
        private location: Location,
        private router: Router,
        private localStorageService: LocalStorageService,
        private deviceService: DeviceService,
        private featureService: FeatureService,
        public initialDataService: InitialDataService,
        private timetableService: TimetableService,
        private sanitizer: DomSanitizer) { }

    ngOnInit() {
        this.buildViewModel(this.availability);
        this.mapEnabled = this.featureService.GetFeatureStatus(Feature.UseGoogleMaps);

        this.fareColours = [ '', '' , '' , '' ];
        this.fareColoursB = [ '', '' , '' , '' ];

        (this.pipe.transform('FareColour1') as Observable<string>).subscribe((value) => {
            this.fareColours[0] = this.sanitizer.bypassSecurityTrustStyle(value);
            this.fareColoursB[0] = value;
        });
        (this.pipe.transform('FareColour2') as Observable<string>).subscribe((value) => {
            this.fareColours[1] = this.sanitizer.bypassSecurityTrustStyle(value);
            this.fareColoursB[1] = value;
        });
        (this.pipe.transform('FareColour3') as Observable<string>).subscribe((value) => {
            this.fareColours[2] = this.sanitizer.bypassSecurityTrustStyle(value);
            this.fareColoursB[2] = value;
        });
        (this.pipe.transform('FareColour4') as Observable<string>).subscribe((value) => {
            this.fareColours[3] = this.sanitizer.bypassSecurityTrustStyle(value);
            this.fareColoursB[3] = value;
        });
    }

    getFareColour(index: number) {
       const result = this.fareColours[index];
       return result;
    }

    checkMaps(ro: RouteOption) {
        // Wait until map is ready.
        if (this.googleMap) {
            this.googleMap.forEach((gmap) => {
            if (Number.parseInt(gmap.index) === ro.index) {
                ro.mapReady = gmap.mapReady;
                gmap.refreshMap();
            }
        });
        } else {
            setTimeout(() => {
                this.checkMaps(ro);
            }, 250);
        }
    }


    buildViewModel(travelAvailability: Availability) {
        // ROUTE OPTIONS
        if (travelAvailability.RouteOptions && travelAvailability.RouteOptions.length > 0) {
            travelAvailability.RouteOptions = travelAvailability.RouteOptions.filter( routeOption => moment(routeOption.DepartureDate).isAfter());
            travelAvailability.RouteOptions = travelAvailability.RouteOptions.filter( routeOption => routeOption.Fares.length >= 1);
        }

        let routeOptionIndex = 0;
        _.each(travelAvailability.RouteOptions,
            (ro: any) => {
                ro.collapsed = true;
                ro.mapReady = false;
                // ro.mapView = !this.deviceService.IsMobile() && this.mapEnabled;
                ro.mapView = false;
                ro.fullRoute = null;
                ro.index = routeOptionIndex;
                ro.Fares.forEach(fare => {
                    if (fare.Price == 0 || fare.RouteSeatsAvailable < 1) {
                        fare.IsSoldOut = true;
                    } else {
                        fare.IsSoldOut = false;
                    }
                });
                
                // ROUTE SECTORS
                _.each(ro.Sectors,
                    (se: any) => {
                        se.BusNumber = se.ServiceCompany + se.ServiceNumber;
                    });

                if (ro.Sectors.length > 1) {
                    ro.ConnectedService = true;
                } else {
                    ro.ConnectedService = false;
                }

                // ROUTE SECTORS SUMMARY
                ro.BusesNumber = _.map(ro.Sectors, 'BusNumber').join(',');
                ro.IsWifiEnabledService = _.some(ro.Sectors,
                    (se: any) => se.IsWifiEnabled);
                ro.WifiSectors = [];
                _.each(ro.Sectors, function (sector) {
                    if (sector['HasWifi']) {
                        ro.WifiSectors.push(sector['ServiceCompany'] + sector['ServiceNumber']);
                    }
                });
                ro.showMap = (inputRo) => {
                    ro.mapView = true;
                    this.checkMaps(inputRo);
                };
                ro.ServiceHasWifi = function (service) {
                    if (ro.WifiSectors.indexOf(service) > -1) {
                        return true;
                    } else {
                        return false;
                    }
                };


                routeOptionIndex++;
            });

        if (travelAvailability.RouteOptions && travelAvailability.RouteOptions.length > 0 && (this.displayFares)) {
            travelAvailability.RouteOptions = travelAvailability.RouteOptions.filter( routeOption => routeOption.Fares.filter(fare => fare.IsSoldOut == false).length > 0);
        }

        this.dayCurrent = moment(this.availability.TravelDate).toDate();

        this.showPreviousDay = true;
        this.showNextDay = true;
        this.availabilityDataExists = !_.isEmpty(travelAvailability.RouteOptions);
        this.nextAvailabilityDateExists = !!travelAvailability.NextAvailabilityDate;
        this.previousAvailabilityDateExists = !!travelAvailability.PreviousAvailabilityDate;
        this.travelAlternates = !!travelAvailability.TravelAlternatives ? travelAvailability.TravelAlternatives : [];
        this.travelAlternatesExist = !!this.travelAlternates && this.travelAlternates.length > 0;
        this.betterTravelAlternatives = !!this.travelAlternates && this.travelAlternates.filter(x => x.BetterAlternative);
        this.betterTravelAlternativesExist = !!this.betterTravelAlternatives && this.betterTravelAlternatives.length > 0;

        if(!travelAvailability.RouteOptions && !!this.travelAlternates) this.showAltTravelPanel = true;
        if(!!travelAvailability.RouteOptions && !!this.betterTravelAlternatives) this.showAltTravelPanel = true;

        if(!!travelAvailability.Messages){
            this.messages = travelAvailability.Messages.filter(x => !x.includes("NOAVL"));
        }
        
        this.getNextPrevDays();
        
        return travelAvailability;
    }

    getNextPrevDays() {
        this.betterDayBefore = null;
        this.betterDayAfter = null;
        this.dayBefore = this.getPreviousTravelDate();
        this.dayAfter = this.getNextTravelDate();
        if(this.betterTravelAlternativesExist){
            this.betterDayBefore = this.getPreviousBetterTravelDate();
            this.betterDayAfter = this.getNextBetterTravelDate();
        }
    }

    getPreviousTravelDate(){
        let retDate: Date | null = null;
        retDate = this.getPreviousAltTravelDate();
        if(!retDate) retDate = !!this.availability.PreviousAvailabilityDate ? moment(this.availability.PreviousAvailabilityDate).toDate() : null;
        if(!retDate) retDate = !!this.availability.PreviousTravelDate ? moment(this.availability.PreviousTravelDate).toDate() : null;
        if(!retDate) retDate = moment(this.dayCurrent).subtract(1, 'days').toDate();
        if(retDate < moment().toDate()) this.showPreviousDay = false;
        return retDate;
    }

    getNextTravelDate(){
        let retDate: Date | null = null;
        retDate = this.getNextAltTravelDate();
        if(!retDate) retDate = !!this.availability.NextAvailabilityDate ? moment(this.availability.NextAvailabilityDate).toDate() : null;
        if(!retDate) retDate = !!this.availability.NextTravelDate ? moment(this.availability.NextTravelDate).toDate() : null;
        if(!retDate) retDate = moment(this.dayCurrent).add(1, 'days').toDate();
        return retDate;
    }

    getPreviousAltTravelDate(){
        if(!this.travelAlternatesExist) return null;
        const alts = this.travelAlternates.filter(x => moment(x.S1DepartTime).toDate() < this.dayCurrent);
        if(!alts || alts.length < 1) return null;
        return moment(alts[alts.length-1].S1DepartTime).toDate();
    }

    getNextAltTravelDate(){
        if(!this.travelAlternatesExist) return null;
        const compareDate = moment(this.dayCurrent).add(1, 'days').toDate();
        const alts = this.travelAlternates.filter(x => moment(x.S1DepartTime).toDate() >= compareDate);
        if(!alts || alts.length < 1) return null;
        return moment(alts[0].S1DepartTime).toDate();
    }

    getPreviousBetterTravelDate(){
        if(!this.betterTravelAlternativesExist) return null;
        const alts = this.betterTravelAlternatives.filter(x => moment(x.S1DepartTime).toDate() < this.dayCurrent);
        if(!alts || alts.length < 1) return null;
        return moment(alts[alts.length-1].S1DepartTime).toDate();
    }

    getNextBetterTravelDate(){
        if(!this.betterTravelAlternativesExist) return null;
        const compareDate = moment(this.dayCurrent).add(1, 'days').toDate();
        const alts = this.betterTravelAlternatives.filter(x => moment(x.S1DepartTime).toDate() >= compareDate);
        if(!alts || alts.length < 1) return null;
        return moment(alts[0].S1DepartTime).toDate();
    }

    getBetterTravelAlternatives(travelAvailability: Availability): Array<TravelAlternative> {
        let betterTravel: Array<TravelAlternative> = [];
        if(!travelAvailability) return betterTravel;
        if(!travelAvailability.RouteOptions) return betterTravel;
        if(!travelAvailability.TravelAlternatives) return betterTravel;
        const routeDistances: number[] = travelAvailability.RouteOptions.map(x => x.RouteDistance); //push all distances into array
        const routeDurations: number[] = travelAvailability.RouteOptions.map(x => x.RouteTotalDuration); //push all durations into array
        const shortestRoute = Math.min.apply(null, routeDistances); //get shortest route
        const quickestRoute = Math.min.apply(null, routeDurations); //get quickest route
        betterTravel = travelAvailability.TravelAlternatives.filter(x => x.TotalDistance + 50 < shortestRoute || x.TripDuration + 30 < quickestRoute);
        return betterTravel;
    }

    dateIsNotToday(selectedDate) {
        return !moment(selectedDate).startOf('day').isSame(moment().startOf('day'));
    }

    handlePreviousDay() {
        const isDisabled = !this.showPreviousDay;
        if (!isDisabled) {
            const previousDay = moment(this.dayBefore).format('YYYY-MM-DD');
            this.refreshAvailability(previousDay);
        }
    }

    handleNextDay = () => {
        const isDisabled = !this.showNextDay;
        if (!isDisabled) {
            const nextDay = moment(this.dayAfter).format('YYYY-MM-DD');
            this.refreshAvailability(nextDay);
        }
    }

    handleBetPreviousDay() {
        if(!!this.betterDayBefore){
            const previousDay = moment(this.betterDayBefore).format('YYYY-MM-DD');
            this.refreshAvailability(previousDay);    
        }
    }

    handleBetNextDay = () => {
        if (!!this.betterDayAfter) {
            const nextDay = moment(this.betterDayAfter).format('YYYY-MM-DD');
            this.refreshAvailability(nextDay);
        }
    }

    calculateFullRoute(data) {
        const fullRoute = [];
        data.forEach(service => {

            service.forEach(stop => {
                fullRoute.push(stop);
            });

            if (fullRoute.length > 1) {
                fullRoute[fullRoute.length - service.length].departing = true;
                fullRoute[fullRoute.length - 1].terminating = true;
            }
        });
        return fullRoute;
    }


    calculateServiceList(data) {
        const serviceList = []
        {
            data.forEach(service => {
                serviceList.push(service[0].CompanyCode.toUpperCase() + service[0].ServiceNumber);
            });
        }
        return serviceList;
    }

    refreshAvailability(newDate: string) {
        newDate = moment(newDate).format('YYYY-MM-DD');
        this.onRefreshAvailabilityByDate.emit(new RefreshAvailabilityByDateOption(newDate, this.currentSlide));
    }

    handleChooseFare = (travelAvailability, routeOption, fare) => {
        if (this.productUrl.ProductTypeUrl === ProductTypeUrl.expressBooking && !!this.productUrl.isManageBooking) {
            this.handleGenericButtonClick(travelAvailability, routeOption);
            return;
        }
        const isFirstLegV = this.currentSlide === 0,
            legName = isFirstLegV ? 'INBOUND' : 'OUTBOUND';

        // Store choosen fare
        this.localStorageService.addTravelToBooking({
            legName: legName,
            travelGuid: travelAvailability.TravelGUID,
            routeNumber: routeOption.RouteNumber,
            fareGuid: fare.FareGUID
        });

        //let hasPromoCode = fare.PromotionCode? "&promoCode="+ fare.PromotionCode : "";

        const currentUrl = document.location.href;
        const currentLocation = document.location.search;
        //const currentReturnDate = currentLocation.split('&');
        const url = currentUrl.replace(currentLocation, '');
        
        travelAvailability.TravelDate = moment(travelAvailability.TravelDate).format('YYYY-MM-DD');

        // SHOULD ANIMATE OR NAVIGATE AWAY?
        if (isFirstLegV && this.hasReturnTrip) {
            this.onMoveToReturnSlide.emit();
            if (history.pushState) {
                // tslint:disable-next-line: max-line-length
                //const newUrl = url + '?origin=' + travelAvailability.DestinationStopCode + '&destination=' + travelAvailability.OriginStopCode + '&travelDate=' + travelAvailability.TravelDate + '&' + currentReturnDate[3] + '&isReturn=true' + hasPromoCode;
                const newUrl = url + '?origin=' + travelAvailability.DestinationStopCode + '&destination=' + travelAvailability.OriginStopCode;
                window.history.pushState({path : newUrl}, '', newUrl);
            }
        } else {

            this.onHandleChooseFare.emit();
            // this.router.navigate(['coach-travel/express-booking/book-now'],
            this.router.navigate([this.initialDataService.expressPassengers],
                {
                    queryParams: {
                        fareGuid: fare.FareGUID,
                        travelGuid: travelAvailability.TravelGUID
                    }
                }
            );
        }
    }

    isMobile() {
        return window.innerWidth < 376;
    }

    // This is called when show fares are false and there are no other buttons but he 'Choose Fare' one at the bottom
    async handleGenericButtonClick(travelAvailability: Availability, routeOption: RouteOption) {
        if (this.addingSector != null) {
            return;
        }

        if (this.productUrl.ProductTypeUrl === ProductTypeUrl.expressBooking && !this.productUrl.isManageBooking) {
            this.handleChooseFare(travelAvailability, routeOption, routeOption.Fares[0]);
            return;
        }

        const isFirstLegV = this.currentSlide === 0;
        // it will be a package
        this.addingSector = routeOption;
        const options = new SectorOptions(this.bookingGuid, travelAvailability.TravelGUID, routeOption.Fares[0].FareGUID);



        if (this.productUrl.ProductTypeUrl === ProductTypeUrl.expressBooking && !!this.productUrl.isManageBooking) {
            const sectorOptions = new SectorOptions(this.bookingGuid,
                travelAvailability.TravelGUID,
                routeOption.Fares[0].FareGUID,
                this.targetSector);
            // replaces an existing sector (Express booking -->Flexi fare<-- basically)
            this.bookingService.updateSector(sectorOptions).subscribe(() => {
                // TODO replace from initial data service
                this.addingSector = null;
                this.router.navigate([`/my-greyhound/booking-management/details`], {
                    queryParams: {
                        bookingGuid: this.bookingGuid,
                        successMessage: 'Trip added successfully.'
                    }
                });
            }, this.onError);
            return;
        }
        // Check if we have already started selecting travel
        this.selectedSectors = this.localStorageService.getSelectedTravelFromBooking(this.bookingGuid);


        this.selectedSectors[this.currentSlide] = options;
        this.localStorageService.setSelectedTravelFromBooking(this.bookingGuid, this.selectedSectors);
        if (this.isAvailabilityPartOfReturnBooking && this.currentSlide === 0) { // We haven't finished selecting all travel yet
            this.onMoveToReturnSlide.emit();
        } else { // We have finished selecting all travel
            // adds a new sector (Passes or Packages)
            const addSectorFunc = this.productUrl.isManageBooking ?
                this.bookingService.addSectorAndCommit : this.bookingService.addSector;
            let sectorIndex = 0;
            for (const newSector of this.selectedSectors) {
                try {
                    const booking: Booking = await addSectorFunc.call(this.bookingService, newSector).toPromise();

                        if (!!this.travelPackageService.bookings) {
                            this.travelPackageService.bookings[0] = booking;
                        }
                        if (isFirstLegV && this.hasReturnTrip) { // has finished
                            this.onMoveToReturnSlide.emit();
                        } else if (sectorIndex === this.selectedSectors.length - 1) {
                            this.localStorageService.removeSelectedTravelFromBooking(this.bookingGuid);
                            if (this.productUrl.isManageBooking) {
                                this.goBackToBookingManagement();
                            } else {
                                // tslint:disable-next-line:max-line-length
                                var productRef = window.location.pathname.split('/')[1];
                                var productDetailsUrl = this.productUrl.ProductDetailsUrl;
                                if(!!productDetailsUrl){
                                    var pdProd = productDetailsUrl.split('/')[1];
                                    if(!!pdProd) productRef = pdProd;
                                }
                                const categoryReference = this.activatedRoute.snapshot.params['category-reference'];
                                const productReference = this.activatedRoute.snapshot.params['product-reference'];

                                this.router.navigate([`/${productRef}/${categoryReference}/${productReference}/book-now/${this.bookingGuid}`]);
                            }
                        }
                } catch (err) {
                    this.onError(err);
                    if (this.context === ITINERARY_CONTEXT.MY_GREYHOUND) {
                        this.goBackToBookingManagement();
                    }
                }
                sectorIndex++;
            }
        }
        this.addingSector = null;
    };
    /**
     * This error should be already parsed to an object
     */
    onError = (error: ApiError) => {
        this.localStorageService.saveError(error);
        this.gettingTimetable = false;
        this.actionUpdaterService.announceError(error);
    }
    private goBackToBookingManagement() {
        this.localStorageService.removeSelectedTravelFromBooking(this.bookingGuid);
        // TODO replace from initial data service
        this.router.navigate([`my-greyhound/booking-management/details`],
            {
                queryParams: {
                    'bookingGuid': this.bookingGuid
                }
            }
        );
    }
    getTimetable(routeOption: RouteOption) {
        this.gettingTimetable = true;
        const serviceDetails = _.map(routeOption.Sectors, (sector: Sector) =>
            new PostTimetableOption(sector.ServiceNumber, sector.OriginStopCode, sector.DestinationStopCode));
        if (!!routeOption.timetable) {
            routeOption.timetableDisplayed = !routeOption.timetableDisplayed;
            routeOption.fullRoute = this.calculateFullRoute(routeOption.timetable);
            routeOption.serviceList = this.calculateServiceList(routeOption.timetable);
            this.gettingTimetable = false;
        } else {
            this.timetableService.postTimetable(serviceDetails, routeOption.DepartureDate).subscribe(
                (timetable) => {
                    this.gettingTimetable = false;
                    this.actionUpdaterService.announceClear(null);
                    routeOption.timetable = timetable;
                    routeOption.timetableDisplayed = true;
                    routeOption.fullRoute = this.calculateFullRoute(timetable);
                    routeOption.serviceList = this.calculateServiceList(timetable);
                }, this.onError
            );
        }

    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/itinerary/travel-dates/availability-table/availability-table.component.ts